import {DatePipe} from '@angular/common';
import {Injectable} from '@angular/core';

import {ICustomViewFilter} from '../../../../../models/custom-view.interface';
import {GridEditTemplate} from '../../../dialogs/models/create-new-view.enum';

@Injectable()
export class ConfigGenerateService {
  private defaultConfig = {
    isDateFilter: false,
    isParentFilter: false,
    isTagsFilter: false,
    isArrayColumns: false,
    predefinedValues: [],
    date: [],
    addedParents: [],
    tagsList: []
  };

  constructor(private datePipe: DatePipe) {}

  public getConfig(editTemplate: string, filter, predefinedOptions) {
    switch (editTemplate) {
      case GridEditTemplate.string:
        return this.getStringColumnFilterConfig();
      case GridEditTemplate.is_exists:
        return this.getStringColumnFilterConfig();
      case GridEditTemplate.integer:
        return this.getNumberColumnFilterConfig();
      case GridEditTemplate.predefined:
        return this.getPredefinedColumnFilterConfig(predefinedOptions);
      case GridEditTemplate.date:
        return this.getDateColumnFilterConfig(filter);
      case GridEditTemplate.query:
        return this.getParentColumnFilterConfig(filter);
      case GridEditTemplate.tags:
        return this.getTagsColumnFilterConfig(filter);
      case GridEditTemplate.predefinedList:
        return this.getPredefinedListColumnFilterConfig(filter, predefinedOptions);
    }
  }

  private getStringColumnFilterConfig() {
    return {...this.defaultConfig};
  }

  private getNumberColumnFilterConfig() {
    return {...this.defaultConfig};
  }

  private getPredefinedColumnFilterConfig(predefinedValues) {
    return {
      ...this.defaultConfig,
      predefinedValues
    };
  }

  private getDateColumnFilterConfig(filter) {
    const {value, secondValue} = filter || {};
    const date = [];

    if (value) {
      date.push(this.datePipe.transform(value, 'MM-dd-yyyy'));
    }

    if (secondValue) {
      date.push(this.datePipe.transform(secondValue, 'MM-dd-yyyy'));
    }

    return {
      ...this.defaultConfig,
      isDateFilter: true,
      date
    };
  }

  private getParentColumnFilterConfig(filter) {
    return {
      ...this.defaultConfig,
      isParentFilter: true,
      isArrayColumns: true,
      addedParents: filter?.values || []
    };
  }

  private getTagsColumnFilterConfig(filter: ICustomViewFilter) {
    return {
      ...this.defaultConfig,
      isTagsFilter: true,
      isArrayColumns: true,
      tagsList: filter?.tags || []
    };
  }

  private getPredefinedListColumnFilterConfig(filter: ICustomViewFilter, predefinedValues) {
    return {
      ...this.defaultConfig,
      isPredefinedListFilter: true,
      isArrayColumns: true,
      predefinedList: filter?.list || [],
      predefinedValues
    };
  }

  public resetConfig() {
    return {...this.defaultConfig};
  }
}
